export const MaterialFractionated = {
  LABELED: "1",
  UNLABELED: "0",
};